import { defineComponent as _defineComponent } from 'vue'
import { DataTable } from '@warrenbrasil/nebraska-web';

import { PortfolioSectionStockItem } from '@/modules/wealth/services/portfolio';
import { columns } from './columns';

interface Props {
  items: PortfolioSectionStockItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StocksTable',
  props: {
    items: null
  },
  setup(__props: any) {



return { __sfc: true,DataTable, columns }
}

})